// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"418a3307","455":"29508aa3","977":"550f88bf"}[chunkId] + ".chunk.js";
};